import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import '../styles/style.css';

import fb from '../../assets/images/facebook.png'
import twt from '../../assets/images/twitter.png'
import yt from '../../assets/images/youTube.png'
import inst from '../../assets/images/instagram.png'

class Footer extends Component {
    render() {
        return (
            <div className="footer">
                {/*<Row className="footer-container">
                      <Col>
                          <ul>
                              <li className="first">Les solutions</li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/solutions/34/plomberie">Plomberie</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/solutions/38/installations-electriques-gaz-chauffage">Electricité</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/solutions/36/gaz">Gaz</a></li>
                          </ul> 
                      </Col>

                      <Col>
                          <ul>
                              <li className="first">Les groupe</li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/homeserve">HomeServe</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/groupe-homeserve">Groupe</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/carrieres">Carrières</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/actualites">Actualités</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/articles-presse-homeserve">Presse</a></li>
                          </ul> 
                      </Col>

                      <Col>
                          <ul>
                              <li className="first">A propos</li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/mentions-legales">Mentions légales</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/conditions-generales-de-vente">CGV</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/accessibilite">Accessibilité</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/confidentialit%C3%A9">Confidentialité</a></li>
                          </ul> 
                      </Col>

                      <Col>
                          <ul>
                              <li className="first">Les contacts</li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/particuliers">Particuliers</a></li>
                              <li><a target="_blank" rel="noopener noreferrer" href="https://www.homeserve.fr/professionnels">Professionnels</a></li>
                          </ul> 
                      </Col>

                      <Col className="right logo-rs">
                          <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HomeServeFrance/"><img alt="" src={fb} /></a>
                          <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/HomeServe_FR"><img alt="" src={twt} /></a>
                          <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/user/DomeoTV"><img alt="" src={yt} /></a>
                          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/homeserve_fr/?univers=2&accomodation=109"><img alt="" src={inst} /></a>
                      </Col>
                  </Row>*/}

                  <Row className="footer-signature">
                      <Col className="nopadding signature">
                          ©HomeServe 2018
                      </Col>
                      <Col className="nopadding">

                      </Col>
                  </Row>

             </div>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/core/components/FooterComponent.js